import {Dispatch} from "redux"
import {connect} from "react-redux"

// Models
import {Record} from "../models"
import {RootState} from "../../../models"

// Selectors
import {selectInterpretation, selectInterpretationUpdated, selectInterpretationUpdating} from "../store/selectors"

// Actions
import {updateRecordInterpretationsAsync} from "../store/actions"

const mapStateToProps = (state: RootState) => ({
    interpretation: selectInterpretation(state),
    isInterpretationUpdating: selectInterpretationUpdating(state),
    isInterpretationUpdated: selectInterpretationUpdated(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    updateInterpretation: (interpretation: Record["interpretation"]) => dispatch(updateRecordInterpretationsAsync.request(interpretation)),
});

export default (BaseComponent: any) => connect(mapStateToProps, mapDispatchToProps)(BaseComponent)

export type WithInterpretationProps = {
    interpretation: Record["interpretation"]
    isInterpretationUpdating: boolean
    isInterpretationUpdated: boolean
    updateInterpretation(interpretation: Record["interpretation"]): void
}
